<ngx-loading [show]="loading"></ngx-loading>
<form (ngSubmit)="save()" [formGroup]="voucherForm">

  <div class="modal-header">
    <h3>
      New Electronic Voucher
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <strong>INSTRUCTIONS TO CLAIMANT</strong>
        <br>
        <ol>
          <li>
            Submit one voucher per period.
          </li>
          <li>
            Details of claim must be specified in description space, including period of time being vouchered for.
          </li>
          <li>
            The voucher cannot be signed or dated prior to the end of the period of time being vouchered for.
          </li>
          <li>
            Amounts indicated on voucher must match the amounts on the financial report.
          </li>
          <li>
            Supporting documents for requested reimbursement of expenses must be submitted for consideration of payment.
          </li>
        </ol>
      </div>
    </div>

    <div class="row m-0">
      <div class="col-md-6 border-right">
        <ngx-title-divider title="Claimant" [bold]="true"></ngx-title-divider>
        <mat-form-field>
          <input placeholder="" formControlName="cv1" matInput/>
        </mat-form-field>
        <mat-form-field>
          <input placeholder="" formControlName="cv2" matInput/>
        </mat-form-field>
        <mat-form-field>
          <input placeholder="" formControlName="cvaddr1" matInput/>
        </mat-form-field>
        <mat-form-field>
          <input placeholder="" formControlName="cvaddr2" matInput/>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <ngx-title-divider title="Taxpayer Identification No." [bold]="true"></ngx-title-divider>
        <mat-form-field>
          <input placeholder="" formControlName="taxid" matInput/>
        </mat-form-field>
        <ngx-title-divider title="Period" [bold]="true"></ngx-title-divider>
        <mat-form-field>
           <mat-select placeholder="" formControlName="period">
             <mat-option [value]="null" [disabled]="true"><strong>Monthly</strong></mat-option>
             <mat-option *ngFor="let p of tagsToMonthlyPeriods | keyvalue:originalOrder" [value]="p.key">
               {{ p.value }}
             </mat-option>
             <mat-option [value]="null" [disabled]="true"><strong>Quarterly</strong></mat-option>
             <mat-option *ngFor="let p of tagsToQuarterlyPeriods | keyvalue:originalOrder" [value]="p.key">
               {{ p.value }}
             </mat-option>
           </mat-select>
         </mat-form-field>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-12">
        <table class="table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Qty</th>
              <th>Unit/Deliverable</th>
              <th>Unit Price</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <mat-form-field>
                  <input placeholder="" formControlName="description1" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="qty1" min="0" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" formControlName="unit1" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="price1" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="sub1" matInput>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field>
                  <input placeholder="" formControlName="description2" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="qty2" min="0" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" formControlName="unit2" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="price2" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="sub2" matInput>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field>
                  <input placeholder="" formControlName="description3" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="qty3" min="0" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" formControlName="unit3" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="price3" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="sub3" matInput>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field>
                  <input placeholder="" formControlName="description4" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="qty4" min="0" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" formControlName="unit4" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="price4" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="sub4" matInput>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field>
                  <input placeholder="" formControlName="description5" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="qty5" min="0" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" formControlName="unit5" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="price5" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="sub5" matInput>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field>
                  <input placeholder="" formControlName="description6" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="qty6" min="0" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" formControlName="unit6" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="price6" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="sub6" matInput>
                </mat-form-field>
              </td>
            </tr>
            <tr>
              <td>
                <mat-form-field>
                  <input placeholder="" formControlName="description7" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="qty7" min="0" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" formControlName="unit7" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="price7" matInput/>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="max-width: 100px;">
                  <input placeholder="" type="number" formControlName="sub7" matInput>
                </mat-form-field>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-8">
        <ngx-title-divider title="TOTAL" [bold]="true"></ngx-title-divider>
        <mat-form-field style="max-width: 100px;">
          <input placeholder="" class="font-weight-bold" type="number" formControlName="total" matInput>
        </mat-form-field>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
    <button class="btn btn-primary"
            [disabled]="voucherForm.invalid">Continue
    </button>
  </div>

</form>